<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 class="card-title mb-0">Grupos de Clientes</h4>
            <div class="small text-muted">Administrar grupos para clasificar clientes</div>
          </b-col>
          <b-col sm="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2">
              <i class="fa fa-plus"></i> Agregar
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-table class="mb-0"
                 ref="table"
                 responsive
                 head-variant="dark"
                 :hover="true"
                 :small="true"
                 :fixed="false"
                 :items="table.items"
                 :fields="table.fields"
                 :current-page="table.currentPage"
                 :per-page="table.perPage"
                 :busy="table.isBusy"
                 v-if="table.items.length || table.isBusy">

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>
          </template>

          <template v-slot:cell(active)="data">
            <b-badge :variant="data.item.active ? 'success' : 'danger'">
              {{ data.item.active ? 'Activo' : 'Inactivo' }}
            </b-badge>
          </template>

          <template v-slot:cell(f_action)="data">
            <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
              <b-dropdown-item @click="edit(data.item)">
                <i class="fa fa-edit mr-0 ml-0" style="color:blue"></i> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="remove(data.item)">
                <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>

        <b-row class="mt-2">
          <b-col>
            <b-pagination
              v-model="table.currentPage"
              :total-rows="table.totalRows"
              :per-page="table.perPage"
              size="sm"
              v-if="table.totalRows > table.perPage">
            </b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <!-- MODAL ADD/EDIT -->
    <b-modal v-model="modal.form.active"
             header-bg-variant="dark"
             header-text-variant="white"
             size="md">
      <div slot="modal-header">
        {{ modal.form.title }}
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group label="Código">
            <b-form-input type="text" size="sm" v-model="crud.form.code" placeholder="Código (opcional)"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Estado">
            <b-form-checkbox v-model="crud.form.active" switch size="sm">
              {{ crud.form.active ? 'Activo' : 'Inactivo' }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Nombre *">
            <b-form-input type="text" size="sm" v-model="crud.form.name" placeholder="Nombre del grupo"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Observaciones">
            <b-form-textarea v-model="crud.form.observations" placeholder="Observaciones (opcional)" rows="3" size="sm"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active = false">Cancelar</b-button>
        <b-button variant="dark" @click="save()">Guardar</b-button>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import ErrorToken from '@/handler/errorToken'

  export default {
    data() {
      return {
        table: {
          items: [],
          fields: [
            { key: 'id', label: 'ID', sortable: true, class: 'text-center', width: '60px' },
            { key: 'code', label: 'Código', sortable: true },
            { key: 'name', label: 'Nombre', sortable: true },
            { key: 'observations', label: 'Observaciones' },
            { key: 'active', label: 'Estado', class: 'text-center', width: '100px' },
            { key: 'f_action', label: '', class: 'text-right', width: '100px' },
          ],
          currentPage: 1,
          perPage: 30,
          totalRows: 0,
          isBusy: false,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            code: '',
            active: true,
            observations: '',
          },
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
        },
      }
    },
    mounted() {
      this.load()
    },
    methods: {
      load() {
        this.table.isBusy = true
        var result = serviceAPI.obtenerGrupos()
        result.then((response) => {
          this.table.items = response.data
          this.table.totalRows = response.data.length
          this.table.isBusy = false
        }).catch(error => {
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error))
        })
      },

      add() {
        this.crud.form = { id: 0, name: '', code: '', active: true, observations: '' }
        this.modal.form.title = 'Agregar Grupo'
        this.modal.form.active = true
      },

      edit(item) {
        this.crud.form = { id: item.id, name: item.name, code: item.code, active: item.active, observations: item.observations || '' }
        this.modal.form.title = 'Editar Grupo'
        this.modal.form.active = true
      },

      save() {
        if (!this.crud.form.name) {
          this.$awn.alert('Debe completar el nombre')
          return
        }

        var result
        if (this.crud.form.id) {
          result = serviceAPI.editarGrupo(this.crud.form)
        } else {
          result = serviceAPI.agregarGrupo(this.crud.form)
        }

        result.then(() => {
          this.modal.form.active = false
          this.load()
          this.$awn.success('Guardado correctamente')
        }).catch(error => {
          this.$awn.alert(ErrorToken.valid(error))
        })
      },

      remove(item) {
        this.$bvModal.msgBoxConfirm('¿Desea eliminar el grupo "' + item.name + '"?', {
          title: 'Confirmar',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
        }).then((value) => {
          if (value) {
            serviceAPI.eliminarGrupo(item.id).then(() => {
              this.load()
              this.$awn.success('Eliminado correctamente')
            }).catch(error => {
              this.$awn.alert(ErrorToken.valid(error))
            })
          }
        })
      },
    },
  }
</script>
